/** User toggles on the risk picture map, by overlay `instanceId`. Absent = untouched. */
export type RiskPictureOverlayVisibility = Readonly<Record<string, boolean>>;

/** A user toggle wins; until then the admin's `enabled_by_default` decides. */
export function riskPictureOverlayVisible(
  overlay: { instanceId: string; enabledByDefault: boolean },
  visibility: RiskPictureOverlayVisibility,
): boolean {
  return visibility[overlay.instanceId] ?? overlay.enabledByDefault;
}
